<template>
  <div class="mycard" @click="$emit('select', reward.id)">
    <img
      class="reward_img"
      v-lazy="reward.posterUrl"
      @load="$emit('image-load')"
      width="100%"
      alt="reward"
    />
    <div class="mycard-body">
      <div class="container">
        <div class="row">
           <div class="col-12 p-0">
            <div class="reward-points">
              <img :src="require('@/assets/icon/BevFamilyPoint.png')" alt="bev point" width="24" height="24" class="mr-1" />
              <span class="point-value">{{ $toLocal(reward.redeemPoint) }}</span>
            </div>
          </div>
          <div class="title_item">{{ reward.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RewardCard",
  props: {
    reward: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.mycard > img {
  min-height: 157px;
  width: 100%;
  height: 157px;
  object-fit: cover;
}

.mycard {
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.mycard-body {
  padding: 0px;
  font-size: 0.8em;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.mycard-body .row > div {
  padding: 2px;
  word-wrap: break-word;
}

.title_item {
  padding: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #000000;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 42px;
}

.reward-points {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  /* height: 21px; */
  padding: 2px 2px;
  background-color: #005224;
}

.point-value {
 
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
}
</style>
